export const DEFAULT_THEME = 'defaultTheme'

const THEME_VARIABLE_PREFIX = '--colorOpacity'

const obterElementosTema = () => {
    if (typeof document === 'undefined') return []

    return [document.documentElement, document.body].filter(Boolean)
}

const limparVariaveisTemaInline = (elemento) => {
    Array.from(elemento.style).forEach((propriedade) => {
        if (propriedade.startsWith(THEME_VARIABLE_PREFIX)) {
            elemento.style.removeProperty(propriedade)
        }
    })
}

export const normalizarNomeTema = (tema) => {
    const nomeTema = String(tema || '').trim()

    return nomeTema || DEFAULT_THEME
}

export const limparTemaDocumento = () => {
    obterElementosTema().forEach((elemento) => {
        elemento.removeAttribute('data-theme')
        limparVariaveisTemaInline(elemento)
    })
}

export const aplicarTemaDocumento = (tema = DEFAULT_THEME) => {
    const nomeTema = normalizarNomeTema(tema)

    if (typeof document === 'undefined') return nomeTema

    limparTemaDocumento()
    document.documentElement.setAttribute('data-theme', nomeTema)

    return nomeTema
}

export const aplicarVariaveisTemaDocumento = (variaveis = {}) => {
    if (typeof document === 'undefined') return

    aplicarTemaDocumento(DEFAULT_THEME)

    Object.entries(variaveis).forEach(([chave, valor]) => {
        if (!valor || typeof valor !== 'string') return

        const nomeVariavel = chave.startsWith('--') ? chave : `--${chave}`
        document.documentElement.style.setProperty(nomeVariavel, valor)
    })
}
